var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrGroupWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 120",
    style: {
      enableBackground: "new 0 0 600 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M374.7,38h-13.9v39.4h13.9V57c0-4.9,1.6-9.2,7.3-9.2c7,0,6.3,6.6,6.3,10.4v19.1h14.1V53 c0-9.7-4.3-16.3-14.9-16.3c-5.5,0-9.5,1.6-12.7,6.3h-0.2V38L374.7,38L374.7,38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.9,38H313v39.4h13.9V57c0-4.9,1.6-9.2,7.3-9.2c6.9,0,6.3,6.6,6.3,10.4v19.1h14.1V53 c0-9.7-4.3-16.3-14.9-16.3c-5.5,0-9.5,1.6-12.7,6.3h-0.2V38L326.9,38L326.9,38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M307.3,38h-13.9v3.8c-3-3.3-7.8-5.1-12.2-5.1c-11.7,0-19.8,9.6-19.8,21c0,11.3,8.2,21.1,19.9,21.1 c4.6,0,9.4-1.7,11.9-5.7h0.2v4.3h13.9V38L307.3,38L307.3,38z M285.1,48.9c5.7,0,9,4,9,8.9c0,5.1-3.3,8.9-9,8.9c-5.7,0-9-3.8-9-8.9 C276.1,52.9,279.4,48.9,285.1,48.9L285.1,48.9L285.1,48.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.6,38h-13.9v39.4h13.9V58.6c0-4.3,0-11.1,6.2-11.1c6.3,0,6.3,6.8,6.3,11.1v18.8h13.9V58.6 c0-4.6,0.3-10.8,6.8-10.8c5.9,0,5.7,6.8,5.7,10.8v18.8h13.9v-25c0-9.2-3.3-15.7-13.5-15.7c-5.4,0-10.6,2.5-13.3,7.6 c-2.8-5.2-7.8-7.6-13.5-7.6c-5,0-9.2,1.9-12.5,6.2h-0.1V38L205.6,38L205.6,38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.2,38v23.7c0,13,9.2,17.1,21.1,17.1c11.9,0,21.1-4.1,21.1-17.1V38h-14.1v21.1c0,5-1.3,8.5-7,8.5 c-5.8,0-7-3.5-7-8.5V38H144.2L144.2,38L144.2,38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.9,38H124v3.8c-3-3.3-7.8-5.1-12.2-5.1c-11.7,0-19.8,9.6-19.8,21c0,11.3,8.2,21.1,19.9,21.1 c4.6,0,9.4-1.7,11.9-5.7h0.2v4.3h13.9V38L137.9,38L137.9,38z M115.4,48.9c5.7,0,9,4,9,8.9c0,5.1-3.3,8.9-9,8.9c-5.7,0-9-3.8-9-8.9 C106.4,52.9,109.7,48.9,115.4,48.9L115.4,48.9L115.4,48.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.9,38H63v39.4h13.9V61.6c0-6.8,1.9-11.9,9.7-11.9c2.2,0,4.1,0.2,6,1.3V37.5h-2.7c-5.5,0-10.1,2-12.8,7 h-0.2V38L76.9,38L76.9,38z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "54.3,49.6 62.2,49.6 62.2,38 54.3,38 54.3,26.1 40.4,26.1 40.4,38 35.8,38 35.8,49.6 40.4,49.6  40.4,77.4 54.3,77.4 54.3,49.6 54.3,49.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.4,39.3c-4.1-1.9-8.5-2.5-13-2.5C11.7,36.7,3,41,3,50.7c0,7.1,4.4,9.3,8.7,10.5c4.4,1.1,8.9,1.2,8.9,4.4 c0,2.1-2.7,3-4.4,3c-3.5,0-8.2-2.1-11.1-4.1L0,74.2c4.7,3,10.3,4.6,16,4.6c9.2,0,18.5-4.3,18.5-14.7c0-7.3-4.9-10.4-11.4-11.7 c-1.9-0.3-6.3-0.8-6.3-3.5c0-1.9,2.8-2.7,4.4-2.7c2.4,0,5.4,0.8,7.5,1.9L33.4,39.3L33.4,39.3L33.4,39.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M448.5,75.5c0,6.1-0.2,11.6-4,16.9c-3.7,5.1-9.6,7.7-15.9,7.7c-10.4,0-19-6.1-19.7-17.1h3.9 c0.4,8.3,7.4,13.4,15.4,13.4c5,0,9.8-1.7,12.8-5.9c3.1-4.6,3.5-9.7,3.5-15.1v-4.9h-0.2c-3.5,4.7-9.5,7.8-15.5,7.8 c-11.5,0-19.3-9.7-19.3-20.9c0-11.5,8.2-20.7,19.8-20.7c6.5,0,11.3,2.8,15,7.8h0.2v-6.9h3.9V75.5z M413.5,57.2 c0,9.1,6,17.4,15.7,17.4c10.2,0,15.7-8.3,15.7-17.8c0-9.2-6.3-16.5-15.9-16.5C419.8,40.3,413.5,48.6,413.5,57.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461.7,42.8h0.2c1.6-3.6,4.4-6,8.6-6c1.6,0,2.8,0.3,4.2,0.9l-2.1,3.4c-0.9-0.5-1.7-0.8-2.8-0.8 c-8.7,0-8.2,10.9-8.2,16.7v20.3h-3.9V37.6h3.9V42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M516.7,57.5c0,11.8-9.2,20.8-20.9,20.8c-11.5,0-20.7-9.4-20.7-20.7c0-11.5,9.1-20.9,20.7-20.9 C507.4,36.7,516.7,45.7,516.7,57.5z M478.9,57.6c0,9,7.2,17.1,16.5,17.1c9.7,0,17.3-7.4,17.3-17.1c0-9.8-7.5-17.2-17.3-17.2 C486,40.3,478.9,48.4,478.9,57.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M552.3,37.6v23.9c0,4,0.1,8.1-2.4,11.5c-2.8,3.6-7.4,5.3-11.9,5.3s-9.1-1.7-11.9-5.3 c-2.5-3.4-2.4-7.4-2.4-11.5V37.6h3.9v22.5c0,7.7,0.9,14.6,10.4,14.6s10.4-6.9,10.4-14.6V37.6H552.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M565,44.7h0.2c2.9-5.1,9.3-8,15.2-8c12.2,0,19.6,9.5,19.6,21.1c0,11.6-7.5,20.4-19.5,20.4 c-6.1,0-12.1-2.7-15.3-7.8H565v30.2h-3.9V37.6h3.9V44.7z M564.8,58.4c0,9.3,6.3,16.3,15.9,16.3c9.3,0,15.5-7.8,15.5-16.7 c0-9.1-5.9-17.6-15.7-17.6C570.3,40.3,564.8,48.8,564.8,58.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrGroupWhite);
export default __webpack_public_path__ + "static/media/str-group-white.ca26bc5a9e6aa9dc749c5323592d12a9.svg";
export { ForwardRef as ReactComponent };